import styles from './Usuarios.module.css';

import { useState } from 'react';

import { IoMdArrowDropdown, IoMdArrowDropup } from 'react-icons/io';

export default function Usuarios({ user, nextUser, backUser, descerItem, subirItem, enviarParaInicio, enviarParaFim, tamanhoTotalLista }) {
  const [ abrirMenuPosicoes, setAbrirMenuPosicoes ] = useState(false);

  return (
    <div onClick={() => setAbrirMenuPosicoes(!abrirMenuPosicoes)} className={styles.container}>
      <div className={styles.menuOpcoes}>
        <p className={styles.icon2}>{abrirMenuPosicoes ? <IoMdArrowDropup/> : <IoMdArrowDropdown/>}</p>
      </div>
      {abrirMenuPosicoes ?
        <div className={styles.containerOpcoes}>
          <button onClick={() => descerItem(user, nextUser)} className={styles.botaoQuadrado}>{<IoMdArrowDropdown/>}</button>
          <button onClick={() => subirItem(user, backUser)} className={styles.botaoQuadrado}>{<IoMdArrowDropup/>}</button>
          <button onClick={() => enviarParaFim(user, tamanhoTotalLista)} className={styles.botao}>Final da Lista</button>
          <button onClick={() => enviarParaInicio(user)} className={styles.botao}>Começo da Lista</button>
        </div>
      :
        <></>
      }
    </div>
  )
}